document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.pes-slider');

  sliders.forEach((slider) => {
    const track = slider.querySelector('.pes-slider-track');
    const slides = Array.from(slider.querySelectorAll('.pes-slide'));
    const dots = Array.from(slider.querySelectorAll('.pes-dot'));

    if (!track || slides.length === 0) return;

    slider.classList.add('js-ready');

    let current = 0;
    let autoplay;
    let startX = 0;
    let startY = 0;
    let currentTranslate = 0;
    let isDragging = false;
    let dragMoved = false;
    let isHorizontalSwipe = false;

    const autoplayEnabled = slider.dataset.autoplayEnabled === 'true';
    const pauseOnHover = slider.dataset.pauseHover === 'true';
    const autoplaySpeed = Number(slider.dataset.autoplay || 5) * 1000;

    function getGap() {
      return window.innerWidth <= 749 ? 0 : 28;
    }

    function getCenterOffset() {
      if (window.innerWidth <= 749) return 0;

      return (slider.offsetWidth - slides[0].offsetWidth) / 2;
    }

    function getSlideWidth() {
      return slides[0].offsetWidth + getGap();
    }

    function getTranslateForIndex(index) {
      return getCenterOffset() - index * getSlideWidth();
    }

    function setDotProgress() {
      dots.forEach((dot, index) => {
        dot.classList.remove('active');
        dot.setAttribute('aria-current', index === current ? 'true' : 'false');
        dot.style.setProperty('--progress-speed', `${autoplaySpeed}ms`);
      });

      if (dots[current]) {
        dots[current].classList.add('active');
      }
    }

    function updateSlider(animate = true) {
      if (!animate) {
        track.classList.add('dragging');
      } else {
        track.classList.remove('dragging');
      }

      currentTranslate = getTranslateForIndex(current);
      track.style.transform = `translateX(${currentTranslate}px)`;

      slides.forEach((slide, index) => {
        slide.classList.toggle('active', index === current);
      });

      setDotProgress();
    }

    function goToSlide(index) {
      if (index < 0) {
        current = slides.length - 1;
      } else if (index >= slides.length) {
        current = 0;
      } else {
        current = index;
      }

      updateSlider(true);
      restartAutoplay();
    }

    function nextSlide() {
      goToSlide(current + 1);
    }

    function previousSlide() {
      goToSlide(current - 1);
    }

    function startAutoplay() {
      clearInterval(autoplay);

      if (autoplayEnabled && slides.length > 1) {
        autoplay = setInterval(nextSlide, autoplaySpeed);
      }
    }

    function stopAutoplay() {
      clearInterval(autoplay);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function getPointerX(event) {
      return event.type.includes('mouse')
        ? event.pageX
        : event.touches[0].clientX;
    }

    function getPointerY(event) {
      return event.type.includes('mouse')
        ? event.pageY
        : event.touches[0].clientY;
    }

    function dragStart(event) {
      if (slides.length <= 1) return;

      isDragging = true;
      dragMoved = false;
      isHorizontalSwipe = false;
      startX = getPointerX(event);
      startY = getPointerY(event);
      stopAutoplay();
    }

    function dragMove(event) {
      if (!isDragging) return;

      const pointerX = getPointerX(event);
      const pointerY = getPointerY(event);
      const diffX = pointerX - startX;
      const diffY = pointerY - startY;

      if (!isHorizontalSwipe && Math.abs(diffY) > Math.abs(diffX) + 8) {
        return;
      }

      if (Math.abs(diffX) > Math.abs(diffY) + 8) {
        isHorizontalSwipe = true;
      }

      if (!isHorizontalSwipe) return;

      if (Math.abs(diffX) > 5) {
        dragMoved = true;
      }

      track.classList.add('dragging');

      const resistance = window.innerWidth <= 749 ? 0.35 : 1;
      const softenedDiff = diffX * resistance;

      track.style.transform = `translateX(${currentTranslate + softenedDiff}px)`;
    }

    function dragEnd(event) {
      if (!isDragging) return;

      isDragging = false;
      track.classList.remove('dragging');

      const endX = event.changedTouches
        ? event.changedTouches[0].clientX
        : event.pageX;

      const diff = endX - startX;
      const threshold =
        slides[0].offsetWidth * (window.innerWidth <= 749 ? 0.22 : 0.15);

      if (isHorizontalSwipe && diff < -threshold) {
        nextSlide();
      } else if (isHorizontalSwipe && diff > threshold) {
        previousSlide();
      } else {
        updateSlider(true);
        restartAutoplay();
      }
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
      });
    });

    track.addEventListener('mousedown', dragStart);
    track.addEventListener('mousemove', dragMove);
    track.addEventListener('touchstart', dragStart, { passive: true });
    track.addEventListener('touchmove', dragMove, { passive: true });

    window.addEventListener('mouseup', dragEnd);
    window.addEventListener('touchend', dragEnd);

    track.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (dragMoved) {
          event.preventDefault();
        }
      });
    });

    if (pauseOnHover) {
      slider.addEventListener('mouseenter', () => {
        if (window.innerWidth > 749) {
          stopAutoplay();
        }
      });

      slider.addEventListener('mouseleave', () => {
        if (window.innerWidth > 749) {
          startAutoplay();
        }
      });
    }

    window.addEventListener('resize', () => {
      updateSlider(false);
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            slider.classList.add('in-view');
          } else {
            slider.classList.remove('in-view');
          }
        });
      },
      {
        threshold: 0.35
      }
    );

    observer.observe(slider);

    updateSlider(true);
    startAutoplay();
  });

  /*
   * Keep the sticky mobile navigation hidden until the first slider with
   * data-mobile-nav-guard="true" has been completely passed.
   */
  const guardedSlider = Array.from(sliders).find(
    (slider) => slider.dataset.mobileNavGuard === 'true'
  );

  if (guardedSlider) {
    const body = document.body;

    function updateMobileNavigationState() {
      const sliderBottom = guardedSlider.getBoundingClientRect().bottom;
      const hasPassedSlider = sliderBottom <= 0;

      body.classList.add('pes-banner-nav-guard');
      body.classList.toggle('pes-banner-passed', hasPassedSlider);
    }

    updateMobileNavigationState();

    const mobileNavigationObserver = new IntersectionObserver(
      () => {
        updateMobileNavigationState();
      },
      {
        threshold: [0, 0.01, 1]
      }
    );

    mobileNavigationObserver.observe(guardedSlider);

    window.addEventListener('resize', updateMobileNavigationState);
    window.addEventListener('orientationchange', updateMobileNavigationState);
    window.addEventListener('pageshow', updateMobileNavigationState);
  }
});